import React, { ReactNode } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ListingImageGallery from "components/ListingImageGallery/bbeImageGallery";
import MobileBookingFooter from "./(components)/BookingFooter";
import FloatingBookingWidget from "./(components)/FloatingBookingWidget";
import { useClient } from "ClientContext";



const DetailPageLayout = ({ children, listingImgs }: {  children: ReactNode; listingImgs?: Array<string> }) => {
  
  const { internal_ID } = useClient();

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const modal = searchParams.get("modal");

const USE_TEST_FOOTER = internal_ID === "0c894dc8-2c42-42fc-ab4e-cfd49662c0a4" || "34931b7c-92cf-400e-84a1-29800a1e529c"; // Toggle for design testing

  const handleCloseModalImageGallery = () => {
    const basePath = location.pathname.replace(/\/photos$/, ""); // Remove "/photos" from the end if it exists
    navigate(`${basePath}`);
  };

  return (
    <div className="ListingDetailPage">
      <ListingImageGallery
        isShowModal={modal === "PHOTO_TOUR_SCROLLABLE"}
        onClose={handleCloseModalImageGallery}
        listingImgs={listingImgs}
      />

      <div className="container ListingDetailPage__content">{children}</div>

      {USE_TEST_FOOTER ? <FloatingBookingWidget /> : <MobileBookingFooter />}
    </div>
  );
};

export default DetailPageLayout;